﻿import '@styles/app.css'
import { initSite } from '@layout/site'
import { mount } from '@shared'
import { OpenExitOffer } from '@features/Services/OpenExitOffer'

initSite()
mount('react-root', <OpenExitOffer />)
